import { Chip, ChipProps } from '@mui/material';

interface StatusConfig {
  color: ChipProps['color'];
  label: string;
}

interface StatusMapping {
  [key: string]: StatusConfig;
}

const subscriptionStatusMap: StatusMapping = {
  active: { color: 'success', label: 'Active' },
  cancelled: { color: 'error', label: 'Cancelled' },
  pending: { color: 'warning', label: 'Pending' },
};

const licenseStatusMap: StatusMapping = {
  issued: { color: 'info', label: 'Issued' },
  active: { color: 'success', label: 'Active' },
  expired: { color: 'error', label: 'Expired' },
};

interface StatusChipProps {
  status: string;
  type: 'subscription' | 'license';
  size?: ChipProps['size'];
}

export default function StatusChip({ status, type, size = 'small' }: StatusChipProps) {
  const statusMap = type === 'subscription' ? subscriptionStatusMap : licenseStatusMap;
  
  const config = statusMap[status] || { color: 'default', label: status };
  
  return (
    <Chip
      label={config.label}
      color={config.color}
      size={size}
      sx={{ fontWeight: 500 }}
    />
  );
}

